module.exports = __webpack_public_path__ + "assets/img/ic-selfdefine.33186b64.svg";